import { useContext } from "react";
import { configStore } from "../contexts/ConfigContext";

export const useLang = () => {
    const {
        config: { lang },
    } = useContext(configStore);
    return lang as string;
};
